import { CALL_FUNDS_DISTRIBUTION_API } from '../../middleware/authHeaders'
import { FUNDS_DISTRIBUTION_API_ROOT } from '../../config/api'
import { errorNotification } from '../application/notifications'

// TYPES & ACTIONS
export const GET_ACCOUNTS_REQUEST = 'GET_ACCOUNTS_REQUEST'
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS'
export const GET_ACCOUNTS_FAILURE = 'GET_ACCOUNTS_FAILURE'

export const getAccounts = () => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'GET',
      endpoint: `${FUNDS_DISTRIBUTION_API_ROOT}/account`,
      types: [GET_ACCOUNTS_REQUEST, GET_ACCOUNTS_SUCCESS, GET_ACCOUNTS_FAILURE],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error fetching accounts`,
          dismissInSeconds: 10,
        })
      )
    }
  })
}

// SELECTORS
export const selectAccounts = state => state.fundsDistribution.accounts

// STATE
const INITIAL_STATE = []
// REDUCERS
const accounts = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_ACCOUNTS_SUCCESS]: (currentState, newPayload) => [...newPayload],
  }[type]?.(state, payload) || state)

export default accounts
